import {MatPaginatorIntl} from '@angular/material/paginator';
import { Injectable } from "@angular/core";
@Injectable()
export class MatPaginatorIntlCro extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Mostrar';
  override nextPageLabel     = 'Siguiente';
  override previousPageLabel = 'Anterior';
}
